export default __webpack_public_path__ + "static/media/element_94.7ee58f1a.webp";